import { useCallback } from "react";
import {useLanguage} from "../../../hooks/hooks";

export function useInquiry() {
  const { isKorean } = useLanguage();
  const emailAddress = "contact@feel-good.io";

  const sendEmail = useCallback(() => {
    const mailToElement = document.createElement("a");
    mailToElement.setAttribute("href", `mailto:${emailAddress}`);
    mailToElement.click();
  }, []);

  const sendKakaotalk = useCallback(() => {
    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", `http://pf.kakao.com/_txlSZxj/chat`);
    linkElement.setAttribute("target", `_blank`);
    linkElement.click();
  }, []);

  const askInquiry = useCallback(() => {
      sendEmail();

    // eslint-disable-next-line
  }, [isKorean, sendKakaotalk, sendEmail]);

  return {
    askInquiry,
  };
}
